import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Send } from 'lucide-react';
import Scanlines from '../components/Scanlines';

const Contact = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState('idle'); // idle, sending, success, error

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    
    try {
      const response = await fetch('https://formspree.io/f/xqeoqdyj', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message
        })
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
        setTimeout(() => setStatus('idle'), 5000);
      } else {
        setStatus('error');
        setTimeout(() => setStatus('idle'), 5000);
      }
    } catch (error) {
      console.error('Error sending message:', error);
      setStatus('error');
      setTimeout(() => setStatus('idle'), 5000);
    }
  };

  return (
    <div className="page-container">
      <Scanlines />
      
      <button onClick={() => navigate('/')} className="back-button">
        <ArrowLeft size={20} />
        <span>BACK</span>
      </button>

      <div className="page-content contact-content">
        <h1 className="page-title-simple">CONTACT</h1>
        
        {status === 'success' ? (
          <div className="contact-success">
            <p>MESSAGE SENT</p>
            <p className="success-subtext">We'll get back to you soon.</p>
          </div>
        ) : status === 'error' ? (
          <div className="contact-success">
            <p>ERROR SENDING</p>
            <p className="success-subtext">Please try again.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="NAME"
                required
                className="form-input"
                disabled={status === 'sending'}
              />
            </div>
            
            <div className="form-group">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="EMAIL"
                required
                className="form-input"
                disabled={status === 'sending'}
              />
            </div>
            
            <div className="form-group">
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="SUBJECT"
                required
                className="form-input"
                disabled={status === 'sending'}
              />
            </div>
            
            <div className="form-group">
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="MESSAGE"
                required
                rows="6"
                className="form-input form-textarea"
                disabled={status === 'sending'}
              ></textarea>
            </div>
            
            <button 
              type="submit" 
              className="form-submit-btn"
              disabled={status === 'sending'}
            >
              <Send size={20} />
              {status === 'sending' ? 'SENDING...' : 'SEND MESSAGE'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Contact;
